import React, { useCallback, useEffect, useState } from 'react';
import { ScreenProps } from '../../../typesInterfacesEnums/componentProps';
import { ComponentWrapper } from '../../helperComponents/ComponentWrapper';
import { PremiumPlans } from '../../helperComponents/PremiumPlans';
import { USER_TYPES } from '../../../typesInterfacesEnums/enums';
import { useSignedInContext } from '../../../context/SignedInContext';
import { BackButton } from '../../helperComponents/BackButton';
import { StyleSheet, Text, View } from 'react-native';
import { mbPlatformStyle } from '@mightybyte/rnw.utils.style-utils';
import { Divider } from '../../helperComponents/Divider';
import { applyTransparency } from '../../../constants/colors';
import { HiveSubscriptionType } from '../../../constants/constants';
import { MB_ToggleSwitch } from '@mightybyte/rnw.components.toggle-switch';
import LinearGradient from 'react-native-linear-gradient';

const Subscriptions = ({ navigation }: ScreenProps<'Subscriptions'>) => {
  const { isSignedIn } = useSignedInContext();
  const [subscriptionType, setSubscriptionType] = useState<HiveSubscriptionType>(
    HiveSubscriptionType.month,
  );

  useEffect(() => {
    if (isSignedIn) {
      navigation.replace('SelectHiveSize');
    }
  }, [isSignedIn, navigation]);

  const onSelectHive = useCallback(() => {
    navigation.navigate('ChooseUserType', { userType: USER_TYPES.teacher });
  }, [navigation]);

  const onSwitchSubscription = useCallback(() => {
    setSubscriptionType(currentSubscriptionType =>
      currentSubscriptionType === HiveSubscriptionType.month
        ? HiveSubscriptionType.year
        : HiveSubscriptionType.month,
    );
  }, []);

  const handleGoBackPress = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.reset({ index: 0, routes: [{ name: 'Lobby' }] });
    }
  };

  return (
    <ComponentWrapper
      hasInset
      hasScroll={true}
      contentContainerStyle={styles.contentContainer}
      containerStyle={styles.container}
    >
      <Divider empty height={20} />
      <Text style={styles.title}>Go Premium!</Text>
      <Divider empty height={30} />
      <View style={styles.subscriptionType}>
        <Text style={styles.subscriptionTypeText}>Monthly</Text>
        <LinearGradient colors={['#FFCF53', '#FF9900']} style={styles.subscriptionTypeSwitch}>
          <MB_ToggleSwitch
            isToggled={subscriptionType === HiveSubscriptionType.year}
            onToggle={onSwitchSubscription}
            trackBar={{
              activeBackgroundColor: 'transparent',
              inActiveBackgroundColor: 'transparent',
              width: 50,
              radius: 30,
              height: 30,
              borderWidth: 2,
              borderActiveColor: 'transparent',
              borderInActiveColor: 'transparent',
            }}
            thumbButton={{
              activeBackgroundColor: '#FFF',
              inActiveBackgroundColor: '#FFF',
              height: 30,
              width: 30,
            }}
            // trackBarStyle={styles.subscriptionTypeSwitch}
          />
        </LinearGradient>
        <Text style={styles.subscriptionTypeText}>Yearly</Text>
      </View>
      <Divider empty height={30} />
      <PremiumPlans subscriptionType={subscriptionType} onSelectHive={onSelectHive} />
      <View style={styles.topContainer}>
        <BackButton text="Back" onPress={handleGoBackPress} />
      </View>
    </ComponentWrapper>
  );
};

export { Subscriptions };

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    minWidth: 1000,
  },
  topContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...mbPlatformStyle({
      mobile: {
        left: 20,
      },
      web: {
        left: 60,
      },
    }),
    position: 'absolute',
    top: 60,
  },
  title: {
    fontFamily: 'Secular One',
    fontSize: 32,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#121212',
  },

  subscriptionType: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  subscriptionTypeSwitch: {
    marginHorizontal: 20,
    borderRadius: 30,
  },
  subscriptionTypeText: {
    fontFamily: 'Secular One',
    fontSize: 16,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#121212',
  },
});
